// extracted by mini-css-extract-plugin
export default {"Content":"content_Content__CCD7h","wrapper":"content_wrapper__-aYAa","Location":"content_Location__37A4T","button":"content_button__FJyIe"};